import React from 'react';
import { Provider } from 'react-redux';
import { withRouter } from '../shared/lib/nextCompat';
import Root from './Root';

const RoutedRoot = withRouter(Root);

export default ctx => {
  const { store, props, Component } = ctx;
  return (
    <Provider store={store}>
      <RoutedRoot>
        <Component {...props} />
      </RoutedRoot>
    </Provider>
  );
};
